import React, { PropTypes } from 'react';
import classNames from 'classnames';

import InputGroup from '../InputGroup';
import BaseField from './Base';


export default class Checkbox extends BaseField {
  static propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    group: PropTypes.shape({}),
    inline: PropTypes.bool.isRequired,
    ommitGroupLabel: PropTypes.bool.isRequired,
  };


  static defaultProps = {
    inline: false,
    ommitGroupLabel: false
  };

  render() {
    const { id } = this.state;
    const {
      ommitGroupLabel,
      inline,
      group,
      label,
      input,
      meta: { error, invalid, touched }
    } = this.props;

    return (
      <InputGroup
        id={id}
        invalid={touched && invalid}
        label={ommitGroupLabel? '' : label}
        {...group}>
        <div className={classNames("from-check", {"form-check-inline": inline })}>
          <label className="form-check-label">
            <input
              className="form-check-input"
              type="checkbox"
              {...input}
            />
            {' '}{label}
          </label>
        </div>
        { (touched && error) && <div className="form-control-feedback">{error}</div> }
      </InputGroup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field/Checkbox.js